import { jsx as a } from "react/jsx-runtime";
import { cn as d } from "../../lib/utils.js";
function n({
  children: t,
  className: e,
  "data-testid": r
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      className: d(
        // The app shell is bounded to the viewport (`h-screen` + `overflow-hidden`),
        // NOT `min-h-screen`: a min-height would grow with content, so a page's
        // `fillHeight` region (e.g. a data grid) could never resolve a definite
        // height and would push the whole window into a scroll instead of
        // scrolling inside its own body. A fixed shell lets the inner
        // `flex-1 min-h-0` chain bound each region so it scrolls internally.
        "flex h-screen w-full overflow-hidden bg-muted/50 p-2 gap-2",
        e
      ),
      "data-testid": r,
      children: t
    }
  );
}
export {
  n as InsetSidebarLayout
};
